import { useRef, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserPreferences } from "../action/cultureAction";
import moment from "moment";

//* Below function to identify the data is empty. Can be validated with object, array and string  */
export const isEmpty = (data) => {
    if (!data) {
        return true;
    }else if (Array.isArray(data)) {
        return data.length ? false : true;
    } else {
        return Object.keys(data).length ? false : true;
    }
};

//* Below function to construct form data payload from source object with array of keys */
export const getFormDataPayload = (data = {}, fieldKeys = []) => {
    const payload = new FormData();
    fieldKeys.map(fieldKey => {
        payload.append([fieldKey], data[fieldKey]);
        return fieldKey;
    });
    return payload;
};

//* Below function to get time abbreviation based on client location */
export const timeZoneAbbreviated = (dateString) => {
    const { 1: tz } = new Date(dateString).toString().match(/\((.+)\)/);
    if (tz.includes(" ")) {
      return tz
        .split(" ")
        .map(([first]) => first)
        .join("");
    } else {
      return tz;
    }
};

//* Below hook is used to make proper setInterval in functional components since set interval will not be cleared properly*/
export const useInterval = (callback, delay) => {
    const savedCallback = useRef();
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    useEffect(() => {
        function tick() {
          savedCallback.current();
        }
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [delay]);
};

//* Below hook is used to get previous props values in functional components */
export const usePrevious = (value) => {
    // The ref object is a generic container whose current property is mutable
    // and it can hold any value, similar to an instance property on a class
    const ref = useRef();
    // Store current value in ref
    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes or we can also try without any dependency
    // Return previous value (happens before update in useEffect above)
    return ref.current;
};

//** Usage of usePrevious hook */
// const [count, setCount] = useState(0);
// const prevCount = usePrevious(count);

//* Below hook to get the date time value based on user preference */
export const useDateTimeByUserFormat = () => {
    const userPreference = useSelector( state => state.userPreferencesRootReducer.UserPreference );
    const dispatch = useDispatch();
    useEffect(() => {
        if (isEmpty(userPreference)) {
            dispatch(getUserPreferences())
        }
    }, [userPreference])

    const dateFormat = ["MMM-DD-YYYY HH:mm", "DD-MMM-YYYY HH:mm", "YYYY-MMM-DD HH:mm"];
    const timeFormat = ["A", ""];
    const dateSeparator = ["-", "/", ".", "_"];

    const getDateTimeValue = useCallback((dateString, dateStringFormat) => {
        if (!isEmpty(userPreference) && dateStringFormat && dateString && moment(dateString, dateStringFormat).isValid()) { // For any given date string format
            const dateValue = new Date(moment(dateString, dateStringFormat).toString());
            return moment(dateValue).format(
                `${dateFormat[userPreference.dateFormat]} ${timeFormat[userPreference.timeFormat]}`.replaceAll("-", dateSeparator[userPreference.dateSeparators])
                ) + " " + timeZoneAbbreviated(dateValue);
        }else if (!isEmpty(userPreference) && dateString && moment(dateString).isValid()) { // For time stamp dateString format
            const dateValue = new Date(dateString);
            return moment(dateValue).format(
                `${dateFormat[userPreference.dateFormat]} ${timeFormat[userPreference.timeFormat]}`.replaceAll("-", dateSeparator[userPreference.dateSeparators])
                ) + " " + timeZoneAbbreviated(dateString);
        } else {
            return `${dateString}`;
        }
    }, [userPreference]);

    return {
        getDateTimeValue
    };
};